import React from 'react'
import { Helmet } from 'react-helmet-async'
import { OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_HOTEL, OFFER_TYPE_BED_BANK } from 'constants/offer'
import { getOfferStructuredData } from './utils'

interface Props {
  offer: App.Offer;
}

function OfferStructuredDataMarkup({ offer }: Props) {
  let structuredData : object | undefined
  // Only show structured data for flash, lpc and lpp.
  if (offer.productType != OFFER_TYPE_ALWAYS_ON && offer.productType != OFFER_TYPE_HOTEL && offer.productType != OFFER_TYPE_BED_BANK) {
    return null
  } else {
    structuredData = getOfferStructuredData(offer)
  }

  return (
    <Helmet>
      <meta name="structuredDataMarkup" content="start" />
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <meta name="structuredDataMarkup" content="end" />
    </Helmet>
  )
}

export default OfferStructuredDataMarkup
